import React from "react";
import { Link } from "react-scroll";
import { useState, useEffect } from "react";
import axios from 'axios';
import { apiKey, baseId, tableName } from "../../airtableConfig";
import { motion, stagger, useAnimate } from "framer-motion";
import { text } from "framer-motion/client";


const API_URL = `https://api.airtable.com/v0/${baseId}/${tableName}`

const airtableAxiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    Authorization: `Bearer ${apiKey}`,
    'Content-Type': 'application/json',
  },
});

const Navbar = ({to, textToDisplay, onClick}) => {

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [someText, setText] = useState('');
  
  const openDialog = () => setIsDialogOpen(true);
  const closeDialog = () => setIsDialogOpen(false);

  const handleChange = (e) => {
    setText(e.target.value);
  };

  const isValidEmail = (email) => {
    // Simple email regex for validation
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const isEmailValid = isValidEmail(someText);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      console.log("Submitted email", someText)
      await airtableAxiosInstance.post('', {
        records: [
        {
          "fields": {
            "email": someText
          }
        }
      ],
      });
      setText('');
      openDialog()

    } catch (error) {
      console.error('Error saving data:', error);
    }
  };

  const getClass = (textToDisplay) => {
    
    if(textToDisplay == "Features"){
      return "left-5 bottom-5 select-none fixed transform -translate-x-1/2 -translate-y-1/2 -rotate-90 text-custom-white z-50 lg:text-3xl sm:text-2xl"
    }
    else if(textToDisplay == "Last Page"){
      return "left-5 bottom-5 select-none fixed transform -translate-x-1/2 -translate-y-1/2 -rotate-90 text-custom-blue z-50 lg:text-3xl sm:text-2xl"
    }
    else if(textToDisplay == "Home Page"){
      return "left-5 bottom-5 select-none fixed transform -translate-x-1/2 -translate-y-1/2 -rotate-90 text-custom-white z-50 lg:text-3xl sm:text-2xl"
    }
    else {
      return "left-5 bottom-5 select-none fixed transform -translate-x-1/2 -translate-y-1/2 -rotate-90 text-custom-blue z-50 lg:text-3xl sm:text-2xl"
    }
    
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 flex justify-center p-4 z-50">
      <div className="container mx-auto flex flex-col sm:flex-row sm:justify-between items-center w-full sm:w-10/12 lg:w-4/12 bg-custom-blue rounded-full">
        <input
          type="text"
          className={`
            "transition duration-200 w-2/3 border p-2 text-center focus:outline-none rounded-l-full m-1
            ${!isEmailValid ? 'border-1 border border-red-500' : 'border-transparent'}"`}
          placeholder="email goes here"
          onChange={handleChange}
          value={someText}
        />
        
        <button 
          className={`${isEmailValid ? 
              "w-1/3 bg-custom-blue text-custom-white rounded-r-full p-2 transition duration-200 ease-in-out hover:bg-custom-white hover:text-custom-blue hover:border hover:border-custom-blue" : 
              "w-1/3 bg-custom-blue text-custom-white rounded-r-full p-2 transition duration-200 ease-in-out hover:bg-custom-white hover:text-custom-blue hover:border hover:border-custom-blue"}`}
           onClick={handleSubmit}
           disabled={!isEmailValid}>
          Sign me up!
        </button>
      </div>
      <DialogBox isOpen={isDialogOpen} onClose={closeDialog}>
        <div>
        <div className="text-5xl font-sans text-custom-blue">Thank you for Hopping!</div>
        
         <TextGenerateEffect 
         words="You signing up means a lot to me. It means people would love to have something as cool as Hop!.
         Will keep you posted on the progress and future roadmap."/>
        </div>
      </DialogBox>
      <Link to={to} smooth={true} duration={500} onClick={onClick}>
        <div className={getClass(textToDisplay)}>
            {textToDisplay}
        </div>
      </Link>
    </div>
  );
  
  
  
  
};

export default Navbar;


const TextGenerateEffect = ({
  words,
  className,
  filter = true,
  duration = 0.5
}) => {
  const [scope, animate] = useAnimate();
  let wordsArray = words.split(" ");
  useEffect(() => {
    animate("span", {
      opacity: 1,
      filter: filter ? "blur(0px)" : "none",
    }, {
      duration: duration ? duration : 1,
      delay: stagger(0.2),
    });
  }, [scope.current]);

  const renderWords = () => {
    return (
      (<motion.div ref={scope}>
        {wordsArray.map((word, idx) => {
          return (
            (<motion.span
              key={word + idx}
              className="dark:text-white text-custom-blue opacity-0 font-sans"
              style={{
                filter: filter ? "blur(10px)" : "none",
              }}>
              {word}{" "}
            </motion.span>)
          );
        })}
      </motion.div>)
    );
  };

  return (
    (<div>
      <div className="mt-4">
        <div
          className=" dark:text-white text-custom-blue text-2xl leading-snug tracking-wide">
          {renderWords()}
        </div>
      </div>
    </div>)
  );
};


const DialogBox = ({ isOpen, onClose, children }) => {
  return (
    <div>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 0.2 } }}
          exit={{ opacity: 0, transition: { duration: 0.2, ease: 'easeOut' } }}
          className="border-5 border-custom-blue fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60"
        >
          <motion.div
            initial={{ scale: 0.7 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0.7 }}
            className="w-11/12 sm:w-[95%] max-w-2xl max-h-[50vh] bg-custom-white dark:bg-neutral-800 rounded-lg shadow-lg p-6 relative"
          >
            <button
              onClick={onClose}
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 dark:hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="h-6 w-6"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M18 6l-12 12" />
                <path d="M6 6l12 12" />
              </svg>
            </button>
            {children}
          </motion.div>
        </motion.div>
      )}
    </div>
  );
};


/*
    <div 
      className="fixed 
      bottom-0 
      left-1/2 
      transform -translate-x-1/2 
      w-full 
      max-w-full 
      lg:w-6/12 lg:pb-5
      sm:w-10/12 sm:pb-5
      z-50"
    >
*/

/*
<div className="bg-custom-blue text-custom-white py-2 rounded-full shadow-lg grid grid-cols-6 gap-2 w-full max-w-3xl">
        
        <Link to={to} smooth={true} duration={500} onClick={onClick} className="col-span-2 sm:col-span-2 lg:col-span-2">
          <button className="bg-custom-blue text-custom-white rounded-full w-full">Button 1</button>
        </Link>
  
        <form onSubmit={handleSubmit} className="col-span-4 sm:col-span-2 lg:col-span-4">
          <input 
            type="text" 
            className="bg-custom-white text-black py-1 rounded-full w-full" 
            onChange={handleChange}
            placeholder="Enter text" 
          />
        </form>
  
        <button className="col-span-2 sm:col-span-2 lg:col-span-2 bg-custom-blue text-custom-white rounded-full w-full">
          Button 2
        </button>
      </div>
*/